import { useEffect } from "react"




const InteractionIframe =(props:any)=>{

  useEffect(()=>{
   // console.log("URL===>",props.urlData)
  },[props.urlData])

    return (<>
    <div>          
    <iframe
        id="myIframe"
        src={props.urlData}
        width="100%"
        height={document.getElementById('iFrameContainer')?.offsetHeight}
        title="Bing"
      />      
      </div>
    </>)

}
export default InteractionIframe